import { tenantConfig } from '../config/tenant'

/**
 * RangeField — a labelled slider with a live value readout, used by the
 * calculator's extra-repayments and offset sections. Formats the readout as
 * currency, a percentage, or a plain number. No em-dashes in any visible copy.
 */
export default function RangeField({
  id,
  label,
  value,
  onChange,
  min,
  max,
  step = 1,
  format = 'number',
  minLabel,
  maxLabel,
}: {
  id: string
  label: string
  value: number
  onChange: (v: number) => void
  min: number
  max: number
  step?: number
  format?: 'currency' | 'percent' | 'number'
  minLabel?: string
  maxLabel?: string
}) {
  const readout =
    format === 'currency'
      ? value.toLocaleString('en-AU', { style: 'currency', currency: 'AUD', maximumFractionDigits: 0 })
      : format === 'percent'
        ? `${value}%`
        : value.toLocaleString('en-AU')

  return (
    <div>
      <div className="flex items-baseline justify-between mb-1">
        <label htmlFor={id} className="text-sm font-medium">{label}</label>
        <span data-testid={`${id}-readout`} className="font-heading text-ink tab-num text-sm">{readout}</span>
      </div>
      <input
        id={id}
        type="range"
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={(e) => onChange(Number(e.target.value))}
        className="w-full"
        style={{ accentColor: tenantConfig.primaryColor }}
      />
      <div className="flex justify-between text-xs text-gs-text-muted mt-1">
        <span>{minLabel ?? (format === 'currency' ? '$0' : String(min))}</span>
        <span>{maxLabel ?? (format === 'currency' ? `$${max.toLocaleString('en-AU')}` : String(max))}</span>
      </div>
    </div>
  )
}
